import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Hexagon } from 'lucide-react';


const PublicLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const getLinkStyle = (path) => {
        const isActive = location.pathname.includes(path);
        return {
            color: isActive ? '#0f172a' : '#64748b',
            textDecoration: 'none',
            fontWeight: isActive ? '700' : '500',
            cursor: 'pointer',
            transition: 'color 0.2s'
        };
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f8fafc', direction: 'ltr' }}>
            <header style={{ position: 'sticky', top: 0, zIndex: 50, backgroundColor: 'rgba(255, 255, 255, 0.8)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #f1f5f9', padding: '15px 5%' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }} onClick={() => navigate('/')}>
                        <Hexagon size={28} color="#3b82f6" fill="#3b82f6" />
                        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '800', color: '#0f172a' }}>Nova<span style={{ color: '#3b82f6' }}>SaaS</span></h1>
                    </div>
                    <nav style={{ display: 'flex', gap: '25px', alignItems: 'center' }}>
                        <button onClick={() => navigate('/features')} style={{ background: 'none', border: 'none', ...getLinkStyle('features') }}>Features</button>
                        <button onClick={() => navigate('/pricing')} style={{ background: 'none', border: 'none', ...getLinkStyle('pricing') }}>Pricing</button>
                        <button onClick={() => navigate('/login')} style={{ padding: '8px 16px', backgroundColor: '#eff6ff', color: '#3b82f6', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}>Sign In</button>
                    </nav>
                </div>
            </header>

            <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <Outlet />
            </main>

            <footer style={{ backgroundColor: '#0f172a', color: '#94a3b8', padding: '60px 5% 30px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px' }}>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
                            <Hexagon size={24} color="#3b82f6" fill="#3b82f6" />
                            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: 'white' }}>NovaSaaS</h2>
                        </div>
                        <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: '20px' }}>Empowering businesses with seamless invoicing, client management, and real-time analytics. Built for modern teams.</p>
                    </div>
                </div>
                <div style={{ maxWidth: '1200px', margin: '40px auto 0', borderTop: '1px solid #1e293b', paddingTop: '30px', textAlign: 'center', fontSize: '13px' }}>
                    &copy; {new Date().getFullYear()} NovaSaaS Solutions Inc. All rights reserved.
                </div>
            </footer>
        </div>
    );
};

export default PublicLayout;